import { CommonModule } from '@angular/common';
import { Component, computed, inject, Input } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedComponentsModule } from '@sbd-doug-frontend/shared/lib/shared-components/shared-components.module';
import { getCollectionSetsForSection, sectionHasQuestions } from '../../../../intake-form.helpers';
import { CIPXQuoteRequestIntakeFormService } from '../../../../intake-form.service';
import { CIPXQuoteRequestIntakeForm, CIPXQuoteRequestIntakeFormStateBondAdditionalQuestionSet } from '../../../../intake-form.types';
import { CIPXQuoteRequestIntakeFormQuestionSetComponent } from '../../../../question-set/question-set.component';
import { CIPXQuoteRequestIntakeFormQuestionCollectionComponent } from '../../../../question-collection/question-collection.component';
import { MaterialModule } from '@sbd-doug-frontend/app/shared/material.module';

@Component({
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    SharedComponentsModule,
    CIPXQuoteRequestIntakeFormQuestionSetComponent,
    CIPXQuoteRequestIntakeFormQuestionCollectionComponent
  ],
  selector: 'cipx-quote-request-intake-form-request-details-screen-and-explain',
  templateUrl: 'screen-and-explain.component.html'
})

export class CIPXQuoteRequestIntakeFormRequestDetailsScreenAndExplainComponent {

  private _intakeService = inject(CIPXQuoteRequestIntakeFormService);
  @Input() quoteRequestForm!: FormGroup<CIPXQuoteRequestIntakeForm>;

  selectedStateBond = this._intakeService.selectedStateBond;
  sectionHasQuestions = sectionHasQuestions;

  /** Only these sections belong to this step; others (state_bond_option_selection,
   *  principal, request_details) render on their own steps. */
  private static readonly STEP_SECTIONS = [
    { name: 'project_information', title: 'Project Information' },
    { name: 'court', title: 'Court Information' },
    { name: 'screening', title: 'Quick Questions' },
  ];

  /** The API's section_label (e.g. "Probate Court Information") overrides the static title. */
  sections = computed(() => {
    const additionalQuestions = this.selectedStateBond()?.additional_questions ?? [];
    return CIPXQuoteRequestIntakeFormRequestDetailsScreenAndExplainComponent.STEP_SECTIONS.map(({ name, title }) => ({
      name,
      title: additionalQuestions.find(section => section.section === name)?.section_label ?? title,
    }));
  });

  collectionSetsBySection = computed<Record<string, CIPXQuoteRequestIntakeFormStateBondAdditionalQuestionSet[]>>(() => {
    const stateBond = this.selectedStateBond();
    if (!stateBond) {
      return {};
    }
    return Object.fromEntries(
      this.sections().map(section => [section.name, getCollectionSetsForSection(section.name, stateBond)])
    );
  });
}
